import { useQueryClient, useMutation } from '@tanstack/react-query';
import { createUserProfile } from '../api/createUserProfile';
import { COLLECTIONS } from '../constants';

export const useCreateUserProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createUserProfile,
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: [COLLECTIONS.users, id] });
    },
  });
};
